import {
  CREATE_BOX,
  CREATE_MANAGERS,
  SET_STATUS_LOCK,
  CANCEL_SAGA,
  PULL_REQUEST,
  CANCEL_SAGA_PULL,
} from './constant';

export function createBoxAction(data, id, getFunc) {
  return {
    type: CREATE_BOX,
    params: data,
    id,
    getFunc,
  };
}

export function createManagers(userId, storageId, getUsers) {
  return {
    type: CREATE_MANAGERS,
    userId,
    storageId,
    getUsers,
  };
}

export function setStatusLock(
  id,
  storageId,
  status,
  getFunc,
  currentStatus,
  setLoader,
) {
  return {
    type: SET_STATUS_LOCK,
    id,
    storageId,
    status,
    getFunc,
    currentStatus,
    setLoader,
  };
}

export function stopRequest() {
  return {
    type: CANCEL_SAGA,
  };
}

export function stopPullRequest() {
  return {
    type: CANCEL_SAGA_PULL,
  };
}

export function pullRequest(id, currentStatus, storageId, getFunc) {
  return {
    type: PULL_REQUEST,
    currentStatus,
    id,
    storageId,
    getFunc,
  };
}
